import axios from 'axios';

// Ensure /api suffix when env base is missing it.
const rawBaseUrl = process.env.REACT_APP_API_URL;
const baseUrl = rawBaseUrl && rawBaseUrl.endsWith('/api') ? rawBaseUrl : `${rawBaseUrl}/api`;

const handleResponse = (response) => {
  if (response?.data) {
    return response.data;
  }
  return {
    isSuccess: false,
    resultMessage: 'Beklenmeyen cevap alındı.',
  };
};

export async function applyForCard(data) {
  try {
    const res = await axios.post(`${baseUrl}/card/apply`, data);
    return handleResponse(res);
  } catch (error) {
    console.error('Card apply error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Başvuru yapılamadı.',
    };
  }
}

export async function loadBalance(data) {
  try {
    const res = await axios.post(`${baseUrl}/card/load-balance`, data);
    return handleResponse(res);
  } catch (error) {
    console.error('Load balance error', error);
    return {
      isSuccess: false,
      resultMessage: error?.response?.data?.resultMessage || error?.message || 'Bakiye yükleme başlatılamadı.',
    };
  }
}

export async function getCardBalance(cardNumber, firstName, lastName) {
    try {
        const res = await axios.get(`${baseUrl}/card/balance/${cardNumber}`, {
            params: { firstName, lastName }
        });
        return handleResponse(res);
    } catch (error) {
        return {
            isSuccess: false,
            resultMessage: error?.response?.status === 404
                ? 'Kart bilgisi bulunamadı.'
                : (error?.response?.data?.resultMessage || error?.message || 'Bakiye sorgulanamadı.')
        };
    }
}

export async function getFitnessBalance(identityNumber, phone) {
    try {
        const res = await axios.post(`${baseUrl}/card/balance-by-identity`, { identityNumber, phone });
        return handleResponse(res);
    } catch (error) {
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Fitness üyelik bilgisi sorgulanamadı.'
        };
    }
}

export async function getCardApplicationFee() {
    try {
        const res = await axios.get(`${baseUrl}/card/application-fee`);
        return handleResponse(res);
    } catch (error) {
        return {
            isSuccess: false,
            resultMessage: error?.message || 'Ücret bilgisi alınamadı.',
            data: { fee: 50.00 } // Default fallback
        };
    }
}

export async function initiateApplicationPayment(data) {
    try {
        const res = await axios.post(`${baseUrl}/card/initiate-application-payment`, data);
        return handleResponse(res);
    } catch (error) {
        console.error('Initiate application payment error', error);
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Başvuru başlatılamadı.',
        };
    }
}

export async function getMembershipPlans(programType, { purchasableOnly = false } = {}) {
    try {
        const res = await axios.get(`${baseUrl}/card/membership-plans`, {
            params: { ...(programType ? { programType } : {}), ...(purchasableOnly ? { purchasableOnly: true } : {}) }
        });
        return handleResponse(res);
    } catch (error) {
        console.error('Get membership plans error', error);
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Üyelik paketleri alınamadı.',
            data: []
        };
    }
}

export async function initiateMembershipPurchase(data) {
    try {
        const res = await axios.post(`${baseUrl}/card/initiate-membership-payment`, data);
        return handleResponse(res);
    } catch (error) {
        console.error('Initiate membership purchase error', error);
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Üyelik paketi satın alma başlatılamadı.',
        };
    }
}

export async function getWomenTrainingFee() {
    try {
        const res = await axios.get(`${baseUrl}/women-training/fee`);
        return handleResponse(res);
    } catch (error) {
        return {
            isSuccess: false,
            resultMessage: error?.message || 'Ücret bilgisi alınamadı.',
            data: { fee: 900.00 }
        };
    }
}

export async function initiateWomenTrainingPayment(data) {
    try {
        const res = await axios.post(`${baseUrl}/women-training/initiate-payment`, data);
        return handleResponse(res);
    } catch (error) {
        console.error('Women training payment error', error);
        return {
            isSuccess: false,
            resultMessage: error?.response?.data?.resultMessage || error?.message || 'Başvuru başlatılamadı.',
        };
    }
}
